import React, { createContext, useState, useCallback } from "react";

export const QuestionVectorContext = createContext({
  questionVectors: [],
  updateQuestionVectors: () => {},
});

export const QuestionVectorProvider = ({ children }) => {
  const [questionVectors, setQuestionVectors] = useState([]);

  const updateQuestionVectors = useCallback((vectors) => {
    setQuestionVectors(vectors && vectors.length ? vectors : []);
  }, []);

  return (
    <QuestionVectorContext.Provider
      value={{
        questionVectors,
        updateQuestionVectors,
      }}
    >
      {children}
    </QuestionVectorContext.Provider>
  );
};
